import React, { useState } from 'react';
import { Paper, Typography, TextField, Select, MenuItem, FormControl, InputLabel, Grid } from '@mui/material';
import ActionButton from '../../components/ActionButton';

const InviteUserForm = () => {
  const [formData, setFormData] = useState({
    email: '',
    role: '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Reset form after submission
    setFormData({ email: '', role: '' });
  };

  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>Invite User</Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel id="role-select-label">Role</InputLabel>
              <Select
                labelId="role-select-label"
                name="role"
                value={formData.role}
                onChange={handleChange}
                required
              >
                <MenuItem value="Admin">Admin</MenuItem>
                <MenuItem value="Editor">Editor</MenuItem>
                <MenuItem value="Viewer">Viewer</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <ActionButton
              text="Send Invitation"
              onClick={handleSubmit}
            />
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

export default InviteUserForm;
